import type { UpdateSavedViewPayload } from '@domain/schemas/payload.schema';
import type { SavedViewResponse } from '@domain/schemas/saved-view.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

export const updateSavedView = async (id: string, data: UpdateSavedViewPayload): Promise<SavedViewResponse> => {
  const networkPayload = await getRequestAuthPayload({ method: 'put', url: `saved-views/${id}`, data });
  const response = await axios(networkPayload);
  return response.data;
};
